import React from "react";
import ProductInfoLine from "./ProductInfoLine";

const ProductInfo = ({ selectedProd, alwaysShowBrand = false }) => {
  if (!selectedProd) return null;

  return (
    <>
      <p className="prod-name">{selectedProd.name}</p>
      <h5 className="product-description">
        {selectedProd.description || "\u00A0"}
      </h5>
      <ProductInfoLine
        product={selectedProd}
        alwaysShowBrand={alwaysShowBrand}
      />
    </>
  );
};

export default ProductInfo;
